<template>
  <div>
    <div class="floating-preview" :class="{ visible: toggleVisible }">
      <div class="preview-trigger" @click="toggleFloatingPreview">
        <i class="fa fa-mobile-alt"></i>
      </div>
      <iframe ref="preview" class="bio-preview no-transform"></iframe>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';

export default Vue.extend({
  data() {
    return {
      logo: '/assets/images/integrations/facebook-pixel@3x.png',
      isLoading: true,
      inProgress: false,
      FBPixel: null,
      toggleVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      marvelousBio: 'setting/marvelousBio',
      teacher: 'user/teacher',
    }),
  },
  methods: {
    async update() {
      this.inProgress = true;
      try {
        await this.$store.dispatch('setting/updateFBPixelID', this.FBPixel);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'SETTINGS.NOTIFICATIONS.FACEBOOK_PIXEL_ID_SUCCESSFULLY_UPDATED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
      this.inProgress = false;
    },
    remove() {
      this.FBPixel = null;
      this.update();
    },
    toggleFloatingPreview() {
      this.toggleVisible = !this.toggleVisible;
    },
  },
  async mounted() {
    this.FBPixel = await this.$store.dispatch('setting/getFBPixelID');
    this.isLoading = false;
    this.$refs[
      'preview'
    ].src = `${process.env.VUE_APP_MARVELOUS_BIO_URL}/${this.teacher.studio_url}`;
  },
  watch: {
    marvelousBio: {
      handler: function (value) {
        this.$refs[
          'preview'
        ].src = `${process.env.VUE_APP_MARVELOUS_BIO_URL}/${this.teacher.studio_url}`;
      },
      deep: true,
    },
    teacher() {
      this.$refs[
        'preview'
      ].src = `${process.env.VUE_APP_MARVELOUS_BIO_URL}/${this.teacher.studio_url}`;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.bio-preview {
  position: sticky;
  top: 2rem;
  width: 350px;
  height: min(100vh, 660px);
  border-radius: 25px;
  border: 3px solid $light-gray;
  transform: scale(0.75) translateY(-6rem);

  @include media-breakpoint-down(sm) {
    width: 330px;
    height: min(100vh, 625px);
  }
}

.floating-preview {
  height: 100%;
  .preview-trigger {
    display: none;
  }
}

@include media-breakpoint-down(sm) {
  .floating-preview {
    position: fixed;
    top: 0;
    right: -330px;
    background-color: transparent;
    z-index: 9999999999;
    transition: all 0.4s ease-out;
    height: min(100vh, 660px);

    .preview-trigger {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      top: calc(50vh - 100px);
      left: -40px;
      color: white;
      background-color: $coral;
      width: 40px;
      height: 40px;
      border-top-left-radius: $border-radius;
      border-bottom-left-radius: $border-radius;
    }

    &.visible {
      right: 0;
    }
  }

  .bio-preview {
    &.no-transform {
      transform: none;
    }
  }
}
</style>
